import { Box, Stack, Typography } from "@mui/material";
import ImageUploaderWithPreview from "@entrilia/shared/components/imageUploader/ImageUploaderWithPreview";
import ImagePlaceholderIcon from "@entrilia/shared/icons/ImagePlaceholderIcon";

interface Props {
  url: string | undefined;
  defaultUrl: string | undefined;
  isLoading: boolean;
  onLogomarkChange: (file: File | undefined, url: string) => void;
  disabled?: boolean;
}

const logomarkImageTypes = ["image/png", "image/svg+xml"];

const CompanyLogomarkSettings = ({ url, defaultUrl, isLoading, disabled, onLogomarkChange }: Props) => {
  return (
    <Stack>
      <Typography variant="subtitle1">Company logomark</Typography>
      <Typography color="textSecondary">PNG or SVG. Recommended size: 56x56 pixels.</Typography>
      <Box sx={{ mt: 2 }}>
        <ImageUploaderWithPreview
          disabled={isLoading || disabled}
          width={56}
          height={56}
          allowedImageTypes={logomarkImageTypes}
          showUploadButtonIcon
          originalImageSrc={defaultUrl}
          imageSrc={url}
          onImageSelected={onLogomarkChange}
          uploadButtonName="Upload Logomark"
          cancelButtonName="Remove"
          maxFileSizeBytes={500_000}
          buttonsPosition="right"
          border="dashed"
          Placeholder={
            <Stack sx={{ p: 2 }}>
              <ImagePlaceholderIcon />
            </Stack>
          }
        />
      </Box>
    </Stack>
  );
};

export default CompanyLogomarkSettings;
